import { customAxios } from './customAxios'
export function getListaUtenzeAssegnatari() {
  const listaUtenzeAssegnatari = customAxios
    .get(
      process.env.REACT_APP_BACKEND_HOST +
        '/' +
        process.env.REACT_APP_PATH_NEW_PREFIX +
        '/get/utenti/assegnatari',
    )
    .then(res => res.data.body)
    .catch(err => [])
  return listaUtenzeAssegnatari
}
